'use client';

import React from 'react';
import OnBoarding from '../../module-components/onboarding/page';
function Onboarding() {
  return <div data-sentry-component="Onboarding" data-sentry-source-file="Onboarding.tsx">
      <OnBoarding data-sentry-element="OnBoarding" data-sentry-source-file="Onboarding.tsx" />
    </div>;
}
export default Onboarding;